import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutRowViewModelType from '@/ViewModels/Controls/ColumnLayoutRowViewModel';
import LabelType from '@/Controls/Label';

export default class ColumnLayoutRow extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;

    public constructor(private viewModel: ColumnLayoutRowViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'columnlayoutrow',

            controlIdent: this.identifier,

            loader: this.viewModel.isBusy,

            visible: this.viewModel.isVisible,

            columnLayoutRow: {
                parent: this,

                items: this.viewModel.items
            }
        });

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('ColumnLayoutRow', ColumnLayoutRow, 'RADPresentation.HTMLClient.DefaultViewExtensions');